import { render, staticRenderFns } from "./SearchLoader.vue?vue&type=template&id=59da0cc0"
import script from "./SearchLoader.vue?vue&type=script&lang=js"
export * from "./SearchLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports